export class ColumnsFilterStorage {
    storeFiltersConfigurationFor(holdingType, columnsToDisplay) {
        throw new Error("Subclass responsibility");
    }

    retrieveFiltersConfigurationFor(holdingType) {
        throw new Error("Subclass responsibility");
    }
}